import { render, staticRenderFns } from "./BsiChangeOfMembership.vue?vue&type=template&id=b138d730&scoped=true&"
import script from "./BsiChangeOfMembership.vue?vue&type=script&lang=js&"
export * from "./BsiChangeOfMembership.vue?vue&type=script&lang=js&"
import style0 from "./BsiChangeOfMembership.vue?vue&type=style&index=0&id=b138d730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b138d730",
  null
  
)

export default component.exports